import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pay-input-container" }

import type { FieldRule } from "vant";
import { Field, Icon } from "vant";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomField',
  props: {
  value: {
    type: String,
  },
  name: {
    type: String,
  },
  rules: {
    type: Array as PropType<FieldRule[]>,
    default() {
      return [];
    },
  },
},
  emits: ["custom-click"],
  setup(__props, { emit: emits }) {




function fn() {
  emits("custom-click");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Field), {
      class: "pay-filed",
      readonly: "",
      clickable: "",
      name: __props.name,
      "model-value": __props.value,
      onClick: fn,
      rules: __props.rules
    }, null, 8, ["name", "model-value", "rules"]),
    _createVNode(_unref(Icon), {
      name: "arrow-down",
      class: "arrow",
      size: "0.3rem"
    })
  ]))
}
}

})